module.exports = __webpack_public_path__ + "img/40_00_079_138.0796587c.jpg";